import React, { useEffect, useState } from "react";
import {
  getSubCategories,
  deleteSubCategory,
} from "../components/subcategory/SubCategoryService";
import { toast } from "react-toastify";
import SubCategoryForm from "../components/subcategory/SubCategoryForm";
import { PencilSquare, Trash } from "react-bootstrap-icons";


function SubCategoryList() {
  
  const [subCategories, setSubCategories] = useState([]);
  const [editData, setEditData] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
  try {
    const res = await getSubCategories();
    setSubCategories(res.data || []);
  } catch (error) {
    console.error("SubCategory API Error:", error);
    setSubCategories([]); // prevent crash
  }
};

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure?")) {
      await deleteSubCategory(id);
      toast.success("Deleted Successfully");
      loadData();
    }
  };

  const filtered = subCategories.filter((item) =>
    item.subCategoryName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-4">
          <SubCategoryForm
            editData={editData}
            refreshList={loadData}
            clearEdit={() => setEditData(null)}
          />
        </div>

        <div className="col-md-8">
          <div className="card shadow-lg p-3 rounded-4">

            <div className="row border-bottom border-1 pb-2">
              <div className="col-md-8"></div>
              <div className="col-md-4">
              <input
                type="text"
                className="form-control w-100"
                placeholder="Search..."
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            </div>

            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((item) => (
                  <tr key={item.subCategoryId}>
                    <td>{item.subCategoryName}</td>
                    <td>{item.categoryName}</td>
                    <td>
                      <span
                        className={`badge ${
                          item.isActive
                            ? "bg-success"
                            : "bg-danger"
                        }`}
                      >
                        {item.isActive ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-warning me-2"
                        onClick={() => setEditData(item)}
                      >
                        <PencilSquare />
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() =>
                          handleDelete(item.subCategoryId)
                        }
                      >
                        <Trash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  );
}

export default SubCategoryList;